export default "__VITE_ASSET__BS$pL3sV__"